import React from 'react';
import { GroupBase, Props, StylesConfig } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import theme from '../theme/theme';
import { ExtendedProps } from './advancedSelect';
function styles<Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(): StylesConfig<Option, IsMulti, Group> {
    return {
        option: (provided, state) => {
            return {
                ...provided,
                fontSize: 14,
                color: state.isSelected ? 'white' : 'black'
            };
        },
        valueContainer: (provided) => {
            return {
                ...provided,
                fontSize: 14,
                color: 'black'
            };
        },
        menu: (provided) => {
            return {
                ...provided,
                zIndex: 2
            };
        },
        control: (provided, state) => {
            return {
                ...provided,
                position: 'relative',
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: state.isFocused ? theme.app.primary : '#DDD',
                boxShadow: 'none',
                minHeight: 40,
                ':hover': {
                    borderColor: theme.app.primary
                }
            };
        }
    };
}
export const AdvancedCreateableSelect = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
    props: Props<Option, IsMulti, Group> & ExtendedProps<Option>
) => {
    return <CreatableSelect {...props} styles={{ ...styles<Option, IsMulti, Group>(), ...props.styles }} />;
};
